export default __webpack_public_path__ + "static/media/appointment.79ad4270.svg";